module.exports = __webpack_public_path__ + "img/emelyanov.a5ca2a9a.jpg";